
















import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import Check from '../../../assets/img/check.svg';
import { mapState as mapRootState } from 'vuex';
export default Vue.extend({
    components: { Check },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            id: uuidv4(),
            checked: this.value,
        };
    },
    computed: {
        ...mapRootState(['portalBranding']),
    },
    watch: {
        checked() {
            this.$emit('input', this.checked);
        },
    },
});
